module.exports = __webpack_public_path__ + "cv.svg?accdfa0ea8efad323ef4711339765a4b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/cv.svg
// module id = 1313
// module chunks = 0